import axios from "axios";
import getConfigByName from "../../../config";

const config = getConfigByName();

// Education articles for Tradersroom in the client's language, from Admin Panel > Education, as one ordered list.
export async function getEducationArticles() {
    try {
        const response = await axios.get(`${config?.backendURL}api/education`, {
            params: {language: localStorage?.getItem("language") || "en"},
        });
        return {
            ...response?.data,
            data: (response?.data?.data || []).flatMap((entry) => entry?.sections || []),
        };
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function getEducationPosting() {
    const cmsUrl = localStorage?.getItem("cmsUrl");
    const lang = localStorage.getItem("language");
    const headers = {
        Authorization: "e01a4b78-d5ca-404e-a63c-7e8c032eeb38",
    };
    // new api dont have this getSectionPosting api
    return await axios({
        url: `https://cmsapi.` + cmsUrl + `/api/section/getSectionPosting?name=education&lang=${lang || "en"}`,
        method: "get",
        headers: headers,
    })
        .then((response) => {
            return response?.data;
        })
        .catch((e) => {
            console.error(e);
            throw e;
        });
}
